import { render, staticRenderFns } from "./autoLogout.vue?vue&type=template&id=2af96529&scoped=true&"
import script from "./autoLogout.vue?vue&type=script&lang=js&"
export * from "./autoLogout.vue?vue&type=script&lang=js&"
import style0 from "./autoLogout.vue?vue&type=style&index=0&id=2af96529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af96529",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af96529')) {
      api.createRecord('2af96529', component.options)
    } else {
      api.reload('2af96529', component.options)
    }
    module.hot.accept("./autoLogout.vue?vue&type=template&id=2af96529&scoped=true&", function () {
      api.rerender('2af96529', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/setting/autoLogout.vue"
export default component.exports